import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_xtn_generic_doc_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_location: fromDatatype.GuidDataFieldInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_machine_code: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.VarcharDatatypeInterface;
  item_desc: fromDatatype.VarcharDatatypeInterface;
  item_remarks: fromDatatype.VarcharDatatypeInterface;
  item_reference_no: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  quantity_signum: fromDatatype.NumericDatatypeInterface;
  quantity_base: fromDatatype.NumericDatatypeInterface;
  qty_reserve_adj: fromDatatype.NumericDatatypeInterface;
  amount_std: fromDatatype.NumericDatatypeInterface;
  amount_discount: fromDatatype.NumericDatatypeInterface;
  amount_net: fromDatatype.NumericDatatypeInterface;
  tax_gst_code: fromDatatype.VarcharDatatypeInterface;
  tax_gst_type: fromDatatype.VarcharDatatypeInterface;
  tax_gst_rate: fromDatatype.NumericDatatypeInterface;
  amount_tax_gst: fromDatatype.NumericDatatypeInterface;
  tax_wht_type: fromDatatype.VarcharDatatypeInterface;
  tax_wht_code: fromDatatype.VarcharDatatypeInterface;
  tax_wht_rate: fromDatatype.NumericDatatypeInterface;
  amount_tax_wht: fromDatatype.NumericDatatypeInterface;
  amount_txn: fromDatatype.NumericDatatypeInterface;
  amount_signum: fromDatatype.NumericDatatypeInterface;
  amount_json: fromDatatype.JsonDatatypeInterface;
  amount_matched: fromDatatype.NumericDatatypeInterface;
  qty_matched: fromDatatype.NumericDatatypeInterface;
  matching_status: fromDatatype.VarcharDatatypeInterface;
  entity_branch_guid: fromDatatype.GuidDataFieldInterface;
  label_json: fromDatatype.JsonDatatypeInterface;
  foreign_ccy: boolean;
  reference_no: fromDatatype.VarcharDatatypeInterface;
  unit_price_by_uom: fromDatatype.NumericDatatypeInterface;
  qty_by_uom: fromDatatype.NumericDatatypeInterface;
  unit_disc_by_uom: fromDatatype.NumericDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_hashed_value: fromDatatype.VarcharDatatypeInterface;
  uom_json: fromDatatype.JsonDatatypeInterface;
  line_property_json: fromDatatype.JsonDatatypeInterface;
  position_id: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  qty_open: fromDatatype.VarcharDatatypeInterface;
  serial_no: fromDatatype.JsonDatatypeInterface;
  batch_no: fromDatatype.JsonDatatypeInterface;
  bin_no: fromDatatype.JsonDatatypeInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_line_guid: fromDatatype.GuidDataFieldInterface;
  item_txn_type: fromDatatype.VarcharDatatypeInterface;
  item_sub_type: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_01: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_02: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_03: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_04: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_05: fromDatatype.VarcharDatatypeInterface;
  guid_location_2: fromDatatype.GuidDataFieldInterface;
  tracking_id: fromDatatype.VarcharDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  unit_price_std: fromDatatype.NumericDatatypeInterface;
  unit_price_txn: fromDatatype.NumericDatatypeInterface;
  unit_price_net: fromDatatype.NumericDatatypeInterface;
  unit_price_std_by_uom: fromDatatype.NumericDatatypeInterface;
  unit_price_txn_by_uom: fromDatatype.NumericDatatypeInterface;
  uom_to_base_ratio: fromDatatype.NumericDatatypeInterface;
  entity_json: fromDatatype.JsonDatatypeInterface;
  consignment_logic: fromDatatype.VarcharDatatypeInterface;
  payment_channel_name: fromDatatype.VarcharDatatypeInterface;
  finance_charge_amount: fromDatatype.NumericDatatypeInterface;
  cost_ma_amount: fromDatatype.NumericDatatypeInterface;
  wf_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_code: fromDatatype.VarcharDatatypeInterface;
  wf_resolution_guid: fromDatatype.GuidDataFieldInterface;
  wf_resolution_code: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;  
}

export class bl_fi_xtn_generic_doc_line_RowClass
  implements bl_fi_xtn_generic_doc_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    client_doc_type: fromDatatype.VarcharDatatypeInterface;
    guid_comp: fromDatatype.GuidDataFieldInterface;
    guid_branch: fromDatatype.GuidDataFieldInterface;
    guid_location: fromDatatype.GuidDataFieldInterface;
    item_guid: fromDatatype.GuidDataFieldInterface;
    item_code: fromDatatype.VarcharDatatypeInterface;
    item_machine_code: fromDatatype.VarcharDatatypeInterface;
    item_name: fromDatatype.VarcharDatatypeInterface;
    item_desc: fromDatatype.VarcharDatatypeInterface;
    item_remarks: fromDatatype.VarcharDatatypeInterface;
    item_reference_no: fromDatatype.VarcharDatatypeInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    txn_code: fromDatatype.VarcharDatatypeInterface;
    quantity_signum: fromDatatype.NumericDatatypeInterface;
    quantity_base: fromDatatype.NumericDatatypeInterface;
    qty_reserve_adj: fromDatatype.NumericDatatypeInterface;
    amount_std: fromDatatype.NumericDatatypeInterface;
    amount_discount: fromDatatype.NumericDatatypeInterface;
    amount_net: fromDatatype.NumericDatatypeInterface;
    tax_gst_code: fromDatatype.VarcharDatatypeInterface;
    tax_gst_type: fromDatatype.VarcharDatatypeInterface;
    tax_gst_rate: fromDatatype.NumericDatatypeInterface;
    amount_tax_gst: fromDatatype.NumericDatatypeInterface;
    tax_wht_type: fromDatatype.VarcharDatatypeInterface;
    tax_wht_code: fromDatatype.VarcharDatatypeInterface;
    tax_wht_rate: fromDatatype.NumericDatatypeInterface;
    amount_tax_wht: fromDatatype.NumericDatatypeInterface;
    amount_txn: fromDatatype.NumericDatatypeInterface;
    amount_signum: fromDatatype.NumericDatatypeInterface;
    amount_json: fromDatatype.JsonDatatypeInterface;
    amount_matched: fromDatatype.NumericDatatypeInterface;
    qty_matched: fromDatatype.NumericDatatypeInterface;
    matching_status: fromDatatype.VarcharDatatypeInterface;
    entity_branch_guid: fromDatatype.GuidDataFieldInterface;
    label_json: fromDatatype.JsonDatatypeInterface;
    foreign_ccy: boolean;
    reference_no: fromDatatype.VarcharDatatypeInterface;
    unit_price_by_uom: fromDatatype.NumericDatatypeInterface;
    qty_by_uom: fromDatatype.NumericDatatypeInterface;
    unit_disc_by_uom: fromDatatype.NumericDatatypeInterface;
    client_key: fromDatatype.VarcharDatatypeInterface;
    client_source: fromDatatype.VarcharDatatypeInterface;
    client_hashed_value: fromDatatype.VarcharDatatypeInterface;
    uom_json: fromDatatype.JsonDatatypeInterface;
    line_property_json: fromDatatype.JsonDatatypeInterface;
    position_id: fromDatatype.VarcharDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    log_json: fromDatatype.JsonDatatypeInterface;
    qty_open: fromDatatype.VarcharDatatypeInterface;
    serial_no: fromDatatype.JsonDatatypeInterface;
    batch_no: fromDatatype.JsonDatatypeInterface;
    bin_no: fromDatatype.JsonDatatypeInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    entity_line_guid: fromDatatype.GuidDataFieldInterface;
    item_txn_type: fromDatatype.VarcharDatatypeInterface;
    item_sub_type: fromDatatype.VarcharDatatypeInterface;
    client_value: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_01: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_02: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_03: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_04: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_05: fromDatatype.VarcharDatatypeInterface;
    guid_location_2: fromDatatype.GuidDataFieldInterface;
    tracking_id: fromDatatype.VarcharDatatypeInterface;
    uom: fromDatatype.VarcharDatatypeInterface;
    unit_price_std: fromDatatype.NumericDatatypeInterface;
    unit_price_txn: fromDatatype.NumericDatatypeInterface;
    unit_price_net: fromDatatype.NumericDatatypeInterface;
    unit_price_std_by_uom: fromDatatype.NumericDatatypeInterface;
    unit_price_txn_by_uom: fromDatatype.NumericDatatypeInterface;
    uom_to_base_ratio: fromDatatype.NumericDatatypeInterface;
    entity_json: fromDatatype.JsonDatatypeInterface;
    consignment_logic: fromDatatype.VarcharDatatypeInterface;
    payment_channel_name: fromDatatype.VarcharDatatypeInterface;
    finance_charge_amount: fromDatatype.NumericDatatypeInterface;
    cost_ma_amount: fromDatatype.NumericDatatypeInterface;
    wf_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
    wf_process_status_guid: fromDatatype.GuidDataFieldInterface;
    wf_process_status_code: fromDatatype.VarcharDatatypeInterface;
    wf_resolution_guid: fromDatatype.GuidDataFieldInterface;
    wf_resolution_code: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    
}
